import React from 'react';
import { Circle, Stack } from '@chakra-ui/react';
import Avatar from '../../avatar';
import getUserName from '../../../../utils/getUserName';
import COLORS from '../../../../constants/colors';
import FONTS from '../../../../constants/fonts';
export const AvatarOrCircle = ({ person, positionStyle, }) => (<Stack position="absolute" {...positionStyle}>
    {person ? (<Avatar name={getUserName(person.person)} width="1rem" height="1rem" borderRadius={20} placeholderFont={FONTS.T1.T10Px.Medium500.value} imageSource={person.picture?.uri}/>) : (<Circle backgroundColor={COLORS.BGFullscreen.value} borderRadius="5rem" size="1rem"/>)}
  </Stack>);
